import { request } from '@services'

export const state = {
  loading: false,
  data: null,
  errors: null,
}

export const getters = {
  getLogList(state) {
    return state.data
  },
}

export const mutations = {
  SET_LOG_LIST_REQUESTED(state) {
    state.loading = true
  },
  SET_LOG_LIST_RECEIVED(state, newData) {
    state.loading = false
    state.data = newData
    state.errors = null
  },
  SET_LOG_LIST_RECEIVED_FAILED(state, error) {
    state.loading = false
    state.errors = error
  },
  RESET_LOG_LIST(state) {
    state.loading = false
    state.data = null
    state.errors = null
  },
}

export const actions = {
  async fetchingLogList({ commit }, params) {
    commit('SET_LOG_LIST_REQUESTED')
    try {
      const response = await request({
        endpoint: '/cms/log/list/',
        payload: { ...params },
      })
      commit('SET_LOG_LIST_RECEIVED', response)
      return response
    } catch (error) {
      commit('SET_LOG_LIST_RECEIVED', error)
    }
  },
  resetLogList({ commit }) {
    commit('RESET_LOG_LIST')
  },
}
